import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import CommonSlider from "../commonComponents/CommonSlider";
import BannerGame from "../commonComponents/BannerGame";
import _ from "lodash";
import Loader from "../commonComponents/Loader";


function Game({similar_txt,view_all,btn_color,play_btn_txt}) {
  console.log("inside game container");
  const [loading,setLoading]=useState(true)
  const { id,title } = useParams();
  console.log(">>>params id:::", id);
  console.log(">>>title is::",title)
  const [curData, setCurData] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const location = useLocation();
  useEffect(() => {
    // setLoading(true);
    let items = JSON.parse(localStorage.getItem("category_data"));
    let cName = JSON.parse(localStorage.getItem("category_name"));
    setCurData(location.state ? location.state.categoryData : items);
    setCategoryName(location.state ? location.state.datacategory : cName);
  }, []);

  function capatalize(categoryName) {
    return categoryName.charAt(0).toUpperCase() + categoryName.slice(1);
  }
  useEffect(() => {
    if (
      curData != "undefined" &&
      curData != "" &&
      curData != null &&
      curData != [] &&
      categoryName != "undefined" &&
      categoryName != "" &&
      categoryName != null &&
      categoryName != []
    ) {
      localStorage.setItem("category_data", JSON.stringify(curData));
      localStorage.setItem("category_name", JSON.stringify(categoryName));
      setLoading(false);
    }
  }, [curData, categoryName]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
  };

  const game = _.find(curData, function (obj) {
    if (parseInt(obj.id) === parseInt(id)) {
      return true;
    }
  });
  
  console.log(">>>game:::", game);

  return (
    <>
      {loading ? (
        <Loader/>
      ) : (
        <React.Fragment>
          {game && (
            <div>
              <BannerGame game={game} color={btn_color} play_btn_txt={play_btn_txt}
              loading={loading} setLoading={setLoading}/>
              <div className="container m-w">
                <CommonSlider
                  settings={{
                    ...settings,
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "10%",
                  }}
                  title={similar_txt}
                  data={curData}
                  view_all={view_all}
                  icon={curData.icon}
                  screen="game"
                  btn_color={btn_color}
                />
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </>
  );
}

export default Game;
